import styled from 'styled-components'

export default styled.div`
  background-position: top right;
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;

  .main {
    margin-top: 2rem;
  }
`
